// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2N6dt","loaderOuter":"PageOverlayLoader_loaderOuter__2Pi_3"};